import * as React from 'react';
// eslint-disable-next-line no-restricted-imports
import { Redirect, RedirectProps } from 'react-router-dom';

import { useConfig } from '../../../../context';
import { mapRoutePath } from '../lib/mapRoutePath';

export const RedirectWrapper: React.FC<RedirectProps> = ({ to, from, ...rest }) => {
	const enabled = useConfig().global.alternativeRouting ?? false;

	const wrappedTo =
		typeof to === 'string'
			? mapRoutePath(to, enabled)
			: to && typeof to === 'object' && typeof to.pathname === 'string'
			? { ...to, pathname: mapRoutePath(to.pathname, enabled) }
			: to;

	const wrappedFrom = typeof from === 'string' ? mapRoutePath(from, enabled) : from;

	return <Redirect to={wrappedTo} from={wrappedFrom} {...rest} />;
};
